import { mapClientModelToProductObject } from './client-model-to-product-object.js';

const mapLineItemToDataLayerEvent = (eventType, lineItems, cartId, isQuantityDiscountSelected)=>{
    if (lineItems.length === 0 || !lineItems[0]) {
        return;
    }
    const currency = lineItems[0].currency;
    const quantity_discount_selected = isQuantityDiscountSelected !== undefined ? isQuantityDiscountSelected ? 'yes' : 'no' : undefined;
    //TODO: Fix it properly with ticket
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(eventType){
        case 'add':
            return {
                event: 'gvAddToCart',
                atfEcommerce: {
                    ecommerce: {
                        currencyCode: currency,
                        quantity_discount_selected,
                        cart: {
                            id: cartId
                        },
                        add: {
                            products: lineItems.map((lineItem)=>mapClientModelToProductObject(lineItem, lineItem.quantity)
                            )
                        }
                    }
                }
            };
        case 'remove':
            return {
                event: 'gvRemoveFromCart',
                atfEcommerce: {
                    ecommerce: {
                        currencyCode: currency,
                        cart: {
                            id: cartId
                        },
                        remove: {
                            products: lineItems.map((lineItem)=>mapClientModelToProductObject(lineItem, lineItem.quantity)
                            )
                        }
                    }
                }
            };
        case 'checkout':
            return {
                event: 'Checkout',
                atfEcommerce: {
                    ecommerce: {
                        currencyCode: currency,
                        cart: {
                            id: cartId
                        },
                        checkout: {
                            actionField: {
                                step: 1
                            },
                            products: lineItems.map((lineItem)=>mapClientModelToProductObject(lineItem, lineItem.quantity)
                            )
                        }
                    }
                }
            };
    }
};

export { mapLineItemToDataLayerEvent };
//# sourceMappingURL=line-item-to-data-layer-event.js.map
